<script lang="ts" setup>
import { computed, onMounted, ref } from '#imports';
import { declareProviders, useService } from '@kaokei/use-vue-service';
import { StorageService } from '@core/services/storage.service';

const storageService = useService(StorageService);
const visible = ref(true);
const handleSendOfflineMessage = () => {
  visible.value = false;
  storageService.setLastOfflineMessageTime(Date.now());
};
function checkVisible() {
  const lastOfflineMessageTime = storageService.getLastOfflineMessageTime();
  if (lastOfflineMessageTime) {
    const now = Date.now();
    const oneDay = 24 * 60 * 60 * 1000;
    if (now - lastOfflineMessageTime < oneDay) {
      return false;
    }
  }
  return true;
}
onMounted(() => {
  visible.value = checkVisible();
});
</script>

<template>
  <div
    v-if="visible"
    class="absolute bottom-0 left-0 right-0 top-0 z-10 flex flex-col items-center justify-center bg-[rgba(0,0,0,0.7)]"
  >
    <div class="text-colorTextWhite text-base">老师未在线，回复可能不及时</div>
    <p class="text-colorTextWhiteSecondary mt-[2px] py-[1px] text-sm">
      建议优先使用微信联系哦~
    </p>
    <a-button
      class="flex-center !mt-3 !flex !h-[40px] w-[204px] !p-0 text-sm"
      size="large"
      type="primary"
      @click="handleSendOfflineMessage"
      >我要给老师发离线消息</a-button
    >
  </div>
</template>
